module.exports = __webpack_public_path__ + "img/cs／pic.33f52edf.png";